import { List, ListItem } from "@mui/material";
import { IRoutePartProps } from "./RouteDescription";
import trafficMessageIconResource from "../../assets/trafficSituation2.svg"
import { FinnishTrafficMessage } from "../../services/RuteplanAPI";


export function FinskeTrafikkmeldinger(props: IRoutePartProps) {
 
    return (
        <>
            {props.roadFeatures && props.roadFeatures.finnishTrafficMessages && 
            <List>
                {props.roadFeatures.finnishTrafficMessages.map( (trafikkmelding: FinnishTrafficMessage, index: number) => (
                    <ListItem
                    key={trafikkmelding.situationId + index} 
                    className="roadFeature"
                    onClick={(event) => {props.onClick(trafikkmelding, event)}}
                    onMouseEnter={() => props.onMouseEnterItem(trafikkmelding)}
                    onMouseLeave={props.onMouseLeaveItem}>            
                        <img src={trafficMessageIconResource} height="24" style={{paddingRight:"5px"}} alt="Trafikkmelding icon" title="trafikkmeldingIcon" />
                        {trafikkmelding.situationId}
                    </ListItem>
                ))}
            </List>
            }
        </>
    )
}